// Page templates (program §6.2 M7-02 "templates (SOP/policy)"): the starter body and kind of a
// new SOP or policy page, as markdown converted by `markdownToBlocks`. New code: Work OS has no
// document templates (its `templates.ts` instantiates a container's tasks).

export type PageTemplateKey = "sop" | "policy" | "kb" | "meeting";

export type PageTemplate = {
  kind: "sop" | "policy" | "kb" | "page";
  label: string;
  /** One line under the label in the New doc picker (DOCS-KB). */
  blurb: string;
  markdown: string;
};

export const PAGE_TEMPLATES: Record<PageTemplateKey, PageTemplate> = {
  sop: {
    kind: "sop",
    label: "SOP",
    blurb: "A procedure people and agents follow step by step.",
    markdown: [
      "## Purpose",
      "What this procedure is for and the result it produces.",
      "",
      "## Scope",
      "Who follows it, and when it applies.",
      "",
      "## Before you start",
      "- [ ] Access and tools needed",
      "- [ ] Inputs to have ready",
      "",
      "## Steps",
      "1. First step",
      "2. Second step",
      "3. Check the result",
      "",
      "## Done when",
      "How to tell the work is complete and correct.",
      "",
      "## Owner and review",
      "Owner: the seat that keeps this procedure current. Review: every quarter.",
    ].join("\n"),
  },
  policy: {
    kind: "policy",
    label: "Policy",
    blurb: "A rule, why it exists, who it covers and who can grant an exception.",
    markdown: [
      "## Policy statement",
      "The rule, in one or two sentences.",
      "",
      "## Why",
      "The reason for the rule and the risk it manages.",
      "",
      "## Applies to",
      "The people, seats, digital employees and situations it covers.",
      "",
      "## Rules",
      "- What must be done",
      "- What must not be done",
      "",
      "## Exceptions",
      "Who may approve an exception, and how it is recorded.",
      "",
      "## Owner and review",
      "Owner: the seat accountable for this policy. Effective from the date it is published.",
    ].join("\n"),
  },
  kb: {
    kind: "kb",
    label: "KB article",
    blurb: "A reference article agents and people read: what is true and where it applies.",
    markdown: [
      "## Summary",
      "The answer in two or three sentences.",
      "",
      "## Details",
      "The facts, numbers and names that matter, in the order a reader needs them.",
      "",
      "## Examples",
      "- A worked example",
      "",
      "## Related",
      "- Links to the SOPs and policies this article supports",
      "",
      "## Last reviewed",
      "Date and reviewer.",
    ].join("\n"),
  },
  meeting: {
    kind: "page",
    label: "Meeting notes",
    blurb: "Attendees, decisions and the actions that came out of a meeting.",
    markdown: [
      "## Attendees",
      "- ",
      "",
      "## Agenda",
      "1. ",
      "",
      "## Notes",
      "",
      "## Decisions",
      "- ",
      "",
      "## Actions",
      "- [ ] Who does what, by when",
    ].join("\n"),
  },
};
